/**
 * Configuraiton for the project
 */

import config from '../../resources/config.generated.json';

export const PROGRAM = config.program;
export const LANGUAGE = config.Language;
export const PROGRAM_URLS = config.url;
